import { motion } from "framer-motion";
import { useState } from "react";

const features = [
  {
    title: "Pan India Network",
    desc:
      "Extensive coverage across major cities and remote regions, enabling seamless nationwide transportation with consistency and reliability.",
    tag: "Connecting every corner of India",
    icon: "📍",
  },
  {
    title: "24/7 Operational Support",
    desc:
      "Round-the-clock monitoring and customer support with real-time shipment visibility and proactive coordination.",
    tag: "Always available, always responsive",
    icon: "⏱️",
  },
  {
    title: "Safe & Secure Movement",
    desc:
      "Advanced safety protocols, GPS-enabled vehicles, and insurance-backed cargo protection across all routes.",
    tag: "Security built into every movement",
    icon: "🛡️",
  },
  {
    title: "Experienced Logistics Team",
    desc:
      "Industry professionals managing operations with precision, accountability, and deep domain expertise.",
    tag: "People who understand logistics",
    icon: "👥",
  },
];

const Features = () => {
  const [active, setActive] = useState(0);
  const isMobile = window.innerWidth < 768;

  return (
    <section
      id="features"
      style={{
        padding: isMobile ? "100px 20px" : "160px 40px",
        background: "#1e3a8a",
        color: "white",
      }}
    >
      {/* HEADING */}
      <div style={{ textAlign: "center", marginBottom: "90px" }}>
        <h2 style={{ fontSize: isMobile ? "36px" : "48px", marginBottom: "14px" }}>
          Why Choose Us
        </h2>
        <p
          style={{
            maxWidth: "760px",
            margin: "0 auto",
            opacity: 0.9,
            fontSize: "16px",
            color: "#dbeafe",
          }}
        >
          Enterprise-grade transportation solutions built on trust,
          discipline, and operational excellence.
        </p>
      </div>

      {/* CARDS */}
      <div
        style={{
          maxWidth: "1200px",
          margin: "0 auto",
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          gap: "26px",
        }}
      >
        {features.map((item, index) => {
          const isActive = active === index;

          return (
            <motion.div
              key={index}
              onMouseEnter={() => !isMobile && setActive(index)}
              animate={
                isMobile
                  ? { opacity: 1, scale: 1 }
                  : {
                      flex: isActive ? 1.6 : 1,
                      opacity: isActive ? 1 : 0.75,
                    }
              }
              transition={{
                type: "spring",
                stiffness: 110,
                damping: 24,
              }}
              style={{
                padding: "36px",
                borderRadius: "26px",
                background:
                  "linear-gradient(180deg, rgba(255,255,255,0.16), rgba(255,255,255,0.06))",
                backdropFilter: "blur(14px)",
                boxShadow: isActive
                  ? "0 50px 100px rgba(0,0,0,0.45)"
                  : "0 22px 46px rgba(0,0,0,0.28)",
              }}
            >
              {/* ICON */}
              <div style={{ fontSize: "34px", marginBottom: "22px" }}>
                {item.icon}
              </div>

              {/* TITLE */}
              <h3
                style={{
                  fontSize: "24px",
                  marginBottom: "14px",
                }}
              >
                {item.title}
              </h3>

              {/* DESC */}
              <p
                style={{
                  fontSize: "15px",
                  lineHeight: "1.7",
                  color: "#e5edff",
                }}
              >
                {item.desc}
              </p>

              {/* TAG */}
              {!isMobile && (
                <motion.p
                  animate={{
                    opacity: isActive ? 1 : 0,
                    y: isActive ? 0 : 10,
                  }}
                  transition={{ duration: 0.3 }}
                  style={{
                    marginTop: "20px",
                    fontSize: "13px",
                    fontStyle: "italic",
                    color: "#bfdbfe",
                  }}
                >
                  “{item.tag}”
                </motion.p>
              )}
            </motion.div>
          );
        })}
      </div>
    </section>
  );
};

export default Features;
